import Vue from 'vue'
import { baseURL } from '@/config/evn'
import axios from 'axios'
import qs from 'qs'
import md5 from 'js-md5'

import { Toast } from 'vant';

const axiosX = axios.create({
  baseURL: baseURL
})

// 校验是否有html标签
function hasHTML (data) {
  data = JSON.stringify(data)
  let reg1 = /<\/?[^>]*>/g
  let reg2 = /&nbsp;/ig
  if (reg1.test(data) || reg2.test(data)) {
    return true
  } else {
    return false
  }
}


const XHR = (isLoading) => {

  const sucFun = res => { // 成功执行方法 
    if (isLoading) {
      Toast.clear()
    }
    return res.data
  }

  const errFun = err => { // 失败执行访求 
    if (isLoading) {
      Toast.clear();
    }
    console.log(err, '失败')
  }

  return { sucFun, errFun }
}

const Get = function (url = '', data = {}, isLoading = false, allowHTML = false) {
  if (!allowHTML && hasHTML(data)) {
    return Promise.resolve({
      msg: '您的填写的数据带有非法字符，请改正后重试'
    })
  }

  if (isLoading) {
    Toast.loading({
      duration: 0,
    });
  }

  let { sucFun, errFun } = XHR()
  let param = {
    ...data
  }
  let str = ''
  for (const key in Vue.prototype.$objKeySort(param)) {
    if (
      Vue.prototype.$objKeySort(param)[key] !== null &&
      typeof Vue.prototype.$objKeySort(param)[key] !== 'undefined'
      && key !== 'file' &&
      key !== 'appVer' &&
      key !== 'mobileMode' &&
      key !== 'appSource' &&
      key !== 'token'
    ) {
      str += Vue.prototype.$objKeySort(param)[key]
    }
  }
  str = md5(str + 'c1d65f3667324592a071ebec5038f38c')
  let params = { params: { ...data, signature: str } }
  return axiosX.get(url, params).then(sucFun).catch(errFun)
}

const Post = function (url = '', data = {}, isLoading = false, allowHTML = false) {
  if (!allowHTML && hasHTML(data)) {
    return Promise.resolve({
      msg: '您的填写的数据带有非法字符，请改正后重试'
    })
  }
  if (isLoading) {
    Toast.loading({
      duration: 0,
    });
  }
  let {
    user,
    sucFun,
    errFun
  } = XHR(isLoading)
  let param = {
    ...user,
    ...data
  }
  let str = ''
  for (const key in Vue.prototype.$objKeySort(param)) {
    if (
      Vue.prototype.$objKeySort(param)[key] !== null &&
      typeof Vue.prototype.$objKeySort(param)[key] !== 'undefined'
      && key !== 'file' &&
      key !== 'appVer' &&
      key !== 'mobileMode' &&
      key !== 'appSource' &&
      key !== 'token' && 
      key !== 'keyword'
    ) {
      str += Vue.prototype.$objKeySort(param)[key]
    }
  }
  str = md5(str + 'c1d65f3667324592a071ebec5038f38c')
  let reqData = qs.stringify({
    ...user,
    ...data,
    signature: str
  })
  return axiosX.post(url, reqData).then(sucFun).catch(errFun)
}

const GetFn = function (url = '', data = {}, isLoading = false, allowHTML = false) {
  if (!allowHTML && hasHTML(data)) {
    return Promise.resolve({
      msg: '您的填写的数据带有非法字符，请改正后重试'
    })
  }
  if (isLoading) {
    Toast.loading({ message: '', duration: 0 });
  }
  let {
    sucFun,
    errFun
  } = XHR(isLoading)
  let param = {
    ...data
  }
  let str = ''
  for (const key in Vue.prototype.$objKeySort(param)) {
    if (
      Vue.prototype.$objKeySort(param)[key] !== null &&
      typeof Vue.prototype.$objKeySort(param)[key] !== 'undefined'
      && key !== 'file' &&
      key !== 'appVer' &&
      key !== 'mobileMode' &&
      key !== 'appSource' &&
      key !== 'token'
    ) {
      str += Vue.prototype.$objKeySort(param)[key]
    }
  }
  str = md5(str + 'c1d65f3667324592a071ebec5038f38c')
  let params = {
    params: {
      ...data,
      signature: str
    }
  }
  return axios.get(url, params).then(sucFun).catch(errFun)
}

const pageCount = (totalnum, limit) => {
  return totalnum > 0 ? ((totalnum < limit) ? 1 : ((totalnum % limit) ? (parseInt(totalnum / limit) + 1) : (totalnum / limit))) : 0;
}




const KeepScrollTop = (Dom, name) => { // 添加监听
  Dom.addEventListener('scroll', scroll)
  function scroll () {
    let scrollNum = Dom && Dom.scrollTop
    sessionStorage.setItem(name, scrollNum)
  }
}

const SetScroll = (Dom, name) => { // 设置返回滚动条位置
  if (sessionStorage.getItem(name)) {
    if (!Dom.scrollTo) {
      Dom.scrollTop = sessionStorage.getItem(name)
    } else {
      Dom.scrollTo(0, sessionStorage.getItem(name))
    }
  }
}

const removeScrollNum = (name) => { // 清除滚动条数值
  if (sessionStorage.getItem(name)) {
    sessionStorage.removeItem(name)
  }
}

const KeepScrollLeft = (Dom, name) => { // 添加横向滚动监听
  Dom.addEventListener('scroll', scroll)
  function scroll () {
    let scrollNum = Dom && Dom.scrollLeft
    sessionStorage.setItem(name, scrollNum)
  }
}

const SetLeftScroll = (Dom, name) => { // 设置返回横向滚动条位置
  if (sessionStorage.getItem(name)) {
    Dom.scrollLeft = sessionStorage.getItem(name)
  }
}
const setBodyScrollToTop = () => { //设置body的y轴滚动置顶
  let Dom = document.getElementsByTagName("body")[0];
  if (!Dom.scrollTo) {
    Dom.scrollTop = 0
  } else {
    Dom.scrollTo(0, 0)
  }
}

Vue.prototype.$KeepScrollTop = KeepScrollTop
Vue.prototype.$SetScroll = SetScroll
Vue.prototype.$removeScrollNum = removeScrollNum
Vue.prototype.$KeepScrollLeft = KeepScrollLeft
Vue.prototype.$SetLeftScroll = SetLeftScroll
Vue.prototype.$setBodyScrollToTop = setBodyScrollToTop


Vue.prototype.$Get = Get
Vue.prototype.$Post = Post
Vue.prototype.$GetFn = GetFn
Vue.prototype.$pageCount = pageCount


// WEBPACK FOOTER //
// ./src/config/axios.js